<template>
  <label :id="id" class="input-label" :for="forId">
    <slot></slot>
  </label>
</template>

<script>
export default {
  name: "InputLabel",
  props: {
    id: { type: String, default: "" },
    forId: { type: String, default: "" },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.input-label {
  display: block;
  margin-top: 5px;
  font-size: 12px;
  color: $dark;
  @include mq-up(md) {
    font-size: 14px;
  }
}
</style>
